(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup-bw"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('newsletter-popup')) return;
    var KEY = 'bw_nlpopup_v1';
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function getState() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
    function setState(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    function norm(v) { return (v || '').trim(); }

    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        this.delay = (parseInt(this.getAttribute('data-delay'), 10) || 10) * 1000;
        this.scrollPct = parseInt(this.getAttribute('data-scroll'), 10) || 45;
        this.design = this.getAttribute('data-design') === 'true';
        this.overlay = this.querySelector('[data-nlpopup-overlay]');
        this.content = this.querySelector('[data-nlpopup-content]');
        this.doneEl = this.querySelector('[data-nlpopup-done]');
        this.lastEl = this.querySelector('[data-nlpopup-last]');
        this.firstEl = this.querySelector('[data-nlpopup-first]');
        this.emailEl = this.querySelector('[data-nlpopup-email]');
        this.newsEl = this.querySelector('[data-nlpopup-news]');
        this.errEl = this.querySelector('[data-nlpopup-error]');
        this.submitBtn = this.querySelector('[data-nlpopup-submit]');
        this.form = this.querySelector('form');

        var self = this;
        this.querySelectorAll('[data-nlpopup-close]').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); self.close(true); });
        });
        this.querySelector('[data-nlpopup-overlay]').addEventListener('click', function () { self.close(true); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(true); });
        this.submitBtn.addEventListener('click', this.submit.bind(this));

        if (this.design) { this.open(); return; }
        if (!this.canShow()) return;
        this.armTriggers();
      }

      canShow() {
        var st = getState();
        if (st.done || st.closed) return false;
        return true;
      }

      armTriggers() {
        var self = this, fired = false;
        function go() { if (fired) return; fired = true; cleanup(); self.open(); }
        var t = setTimeout(go, this.delay);
        function onScroll() {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          var pct = max > 0 ? (window.scrollY / max * 100) : 0;
          if (pct >= self.scrollPct) go();
        }
        function cleanup() { clearTimeout(t); window.removeEventListener('scroll', onScroll); }
        window.addEventListener('scroll', onScroll, { passive: true });
        this._cleanup = cleanup;
      }

      open() {
        this.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var self = this;
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.classList.add('is-open'); }); });
        setTimeout(function () { try { self.lastEl.focus({ preventScroll: true }); } catch (e) {} }, 320);
      }

      close(remember) {
        if (this._cleanup) this._cleanup();
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (remember && !this.design) { var st = getState(); st.closed = true; setState(st); }
        var self = this;
        setTimeout(function () { self.hidden = true; }, 650);
      }

      showErr(msg) { this.errEl.textContent = msg; this.errEl.hidden = false; }

      submit() {
        var last = norm(this.lastEl.value), first = norm(this.firstEl.value), email = norm(this.emailEl.value), consent = !!this.newsEl.checked;
        if (!consent) { this.showErr(this.getAttribute('data-msg-consent')); return; }
        if (!last || !first || !EMAIL.test(email)) { this.showErr(this.getAttribute('data-msg-error')); return; }
        this.errEl.hidden = true; this.submitBtn.disabled = true;
        this.form.querySelector('[data-nlpopup-f-email]').value = email;
        var l = this.form.querySelector('[data-nlpopup-f-last]'); if (l) l.value = last;
        var n = this.form.querySelector('[data-nlpopup-f-first]'); if (n) n.value = first;
        var self = this;
        fetch(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.ok || r.redirected || r.status === 0; })
          .then(function (good) {
            self.submitBtn.disabled = false;
            if (good) { var st = getState(); st.done = true; setState(st); self.content.hidden = true; self.doneEl.hidden = false; }
            else { self.showErr(self.getAttribute('data-msg-error')); }
          })
          .catch(function () { self.submitBtn.disabled = false; self.showErr(self.getAttribute('data-msg-error')); });
      }
    }
    customElements.define('newsletter-popup', NewsletterPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
